class FrameAnimation extends HTMLElement {
  constructor(){
    super();
		this.canvas = this.querySelector('canvas');
    this.canvasWrapper = this.querySelector('.canvas-wrapper');
    this.context = this.canvas.getContext('2d');
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    this.canvas.width = this.windowWidth;
    this.canvas.height = this.windowHeight;
    this.images = [];
    this.frames = {
      frame: 1
    };
    this.animationType = this.dataset.animationType;
    this.initialText = this.querySelector('.progress-text div:first-child');
    this.scrollText = this.querySelector('.progress-text div:last-child');

    switch(this.animationType) {

      case 'face_day':
        this.framesCount = 104;
        break;

      case 'face_night':
        this.framesCount = 104;
        break;

      case 'liquid_night':
        this.framesCount = 94;
        break;

      case 'liquid_day':
        this.framesCount = 104;
        break;
    }
  }

  connectedCallback() {
    this.pushImages();
    this.gsapInit();
  }

  disconnectedCallback() {
  }

  getFrame(index) {
    if(this.windowWidth < 989) {
      switch (this.animationType) {
        case 'face_day':
          return `https://cdn.shopify.com/s/files/1/0568/4871/1714/files/mobile_face_day_${(index).toString()}.png?v=1732786027`;

        case 'face_night':
          return `https://cdn.shopify.com/s/files/1/0568/4871/1714/files/mobile_face_night_${(index).toString()}.png?v=1732785846`;

        case 'liquid_night':
          return `https://cdn.shopify.com/s/files/1/0568/4871/1714/files/mobile_liquid_night_${(index).toString()}.png?v=1733418496`

        case 'liquid_day':
          return `https://cdn.shopify.com/s/files/1/0568/4871/1714/files/mobile_liquid_day_${(index).toString()}.png?v=1733418425`

      }
    }
    else {
      switch (this.animationType) {
        case 'face_day':
          return `https://cdn.shopify.com/s/files/1/0568/4871/1714/files/desktop_face_day_${(index).toString()}.png?v=1731963815`

        case 'face_night':
          return `https://cdn.shopify.com/s/files/1/0568/4871/1714/files/desktop_face_night_${(index).toString()}.png?v=1731963060`;

        case 'liquid_night':
          return `https://cdn.shopify.com/s/files/1/0568/4871/1714/files/desktop_liquid_night_${(index).toString()}.png?v=1731964017`;

        case 'liquid_day':
          return `https://cdn.shopify.com/s/files/1/0568/4871/1714/files/desktop_liquid_day_${(index).toString()}.png?v=1731964095`;

      }
    }
  }

  pushImages() {
    for (let i = 0; i < this.framesCount; i++) {
      const img = new Image();
      img.src = this.getFrame(i);
      this.images.push(img);
    }
    this.images[1].addEventListener('load', this.renderFirstImage.bind(this));
  }

  renderFirstImage() {
    this.imagesHeight = this.images[1].naturalHeight / 1.2;
    this.imagesWidth = this.images[1].naturalWidth / 1.2;
    this.renderImage();
  }

  gsapInit() {
    this.gsapMainAnimationInit(this.frames, this.framesCount, this.renderImage.bind(this), this.canvasWrapper);
  }

  gsapMainAnimationInit(frames, framesCount, renderImage, trigger) {
    gsap.to(frames, {
      frame: framesCount - 1,
      snap: "frame",
      ease: "none",
      scrollTrigger: {
        scrub: 0.2,
        trigger: trigger,
        start: "top top",
        end: "bottom bottom",
        onEnter: () => {
          this.startAnimation();
          this.showScrollText();
        },
        onEnterBack: () => {
          this.showTextAnimation();
        },
        onLeaveBack: () => {
            this.showInitialText();
            this.stopAnimation();
        },
        onLeave: () => {
          this.hideTextAnimation();
        }
      },
      onUpdate: renderImage // use animation onUpdate instead of scrollTrigger's onUpdate
    });
  }

  hideTextAnimation() {
    this.querySelector('.animation-progress').classList.add('animation-hidden');
  }

  showTextAnimation() {
    this.querySelector('.animation-progress').classList.remove('animation-hidden');
  }

  startAnimation() {
    this.querySelector('.animation-progress').classList.add('animation-active');
  }

  stopAnimation() {
    this.querySelector('.animation-progress').classList.remove('animation-active');
  }

  showInitialText() {
    this.initialText.classList.add('text-visible');
    this.scrollText.classList.remove('text-visible');
  }

  showScrollText() {
    this.scrollText.classList.add('text-visible');
    this.initialText.classList.remove('text-visible');
  }

  renderImage() {
    const tempFrames = this.frames;
    const tempImages = this.images;
    const canvasWidth = this.canvas.width;
    const canvasHeight = this.canvas.height;
    let ImageWidth = 0;
    let imageHeight = 0;
    if(window.innerWidth < 990) {
      ImageWidth = canvasWidth;
      imageHeight = canvasHeight;
    }
    else {
      ImageWidth = this.imagesWidth;
      imageHeight = this.imagesHeight;
    }
    const imagePosX = canvasWidth/2 - ImageWidth/2;
    const imagePosY = canvasHeight/2 - imageHeight/2 - 25;
    this.context.clearRect(imagePosX, imagePosY, ImageWidth, imageHeight);
    this.context.drawImage(tempImages[tempFrames.frame], imagePosX, imagePosY, ImageWidth , imageHeight);
  }
}

if (!window.customElements.get("frame-animation")) {
  window.customElements.define("frame-animation", FrameAnimation);
}

